import ClipperPlaceholder from './ClipperPlaceholder.jsx';

export default function FacturarUnEnvioDeContado() {
  return (
    <ClipperPlaceholder title="Facturar Un Envío de Contado" category="Operativas" />
  );
}
